export default function ElectriciteGrid() {
  const products = [
    {
      name: 'Tableau ABB System Pro M',
      category: 'Tableau électrique modulaire',
      capacity: '3 rangées - 54 modules',
      image: 'https://readdy.ai/api/search-image?query=Premium%20ABB%20System%20Pro%20M%20electrical%20distribution%20board%20with%20modular%20circuit%20breakers%20in%20pristine%20white%20housing%2C%20professional%20product%20photography%20showing%20organized%20three-row%20panel%20with%20ABB%20branded%20components%2C%20high-end%20residential%20electrical%20equipment%20with%20clean%20modern%20design%20against%20white%20background%2C%20Swiss%20quality%20electrical%20installation%20system&width=800&height=600&seq=abb-system-pro&orientation=portrait',
      features: [
        'Disjoncteurs ABB S200 courbe C',
        'Interrupteur différentiel 30mA type A',
        'Parafoudre type 2 intégré',
        'Borniers de connexion rapide',
        'Certification OIBT/NIBT complète'
      ],
      specs: { brand: 'ABB', standard: 'OIBT/NIBT', warranty: '10 ans' }
    },
    {
      name: 'Domotique KNX Premium',
      category: 'Système domotique complet',
      capacity: 'Installation 4 pièces',
      image: 'https://readdy.ai/api/search-image?query=Sophisticated%20KNX%20home%20automation%20control%20panel%20with%20elegant%20touchscreen%20interface%20displaying%20room%20controls%2C%20premium%20smart%20home%20system%20with%20sleek%20black%20glass%20finish%20and%20intuitive%20UI%2C%20high-end%20building%20automation%20technology%20with%20modern%20minimalist%20design%2C%20professional%20product%20photography%20on%20white%20background&width=800&height=600&seq=knx-premium&orientation=portrait',
      features: [
        'Écrans tactiles KNX 7 pouces',
        'Contrôle éclairage intelligent',
        'Gestion stores et volets',
        'Thermostat connecté par zone',
        'Application mobile iOS/Android'
      ],
      specs: { brand: 'KNX Certified', standard: 'KNX International', warranty: '5 ans' }
    },
    {
      name: 'Borne Recharge VE Wallbox',
      category: 'Borne de recharge véhicule électrique',
      capacity: '22 kW triphasé',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Wallbox%20electric%20vehicle%20charging%20station%20in%20sleek%20white%20finish%20with%20LED%20status%20indicators%2C%20premium%20EV%20charger%20with%20minimalist%20Scandinavian%20design%20and%20Type%202%20cable%2C%20high-end%20residential%20charging%20solution%20with%20smart%20connectivity%20features%2C%20professional%20product%20photography%20against%20clean%20background&width=800&height=600&seq=wallbox-ev&orientation=portrait',
      features: [
        'Charge rapide 22 kW',
        'Câble Type 2 intégré 5m',
        'Gestion de charge intelligente',
        'Protection IP54 extérieur',
        'Connexion WiFi et application'
      ],
      specs: { brand: 'Wallbox', standard: 'IEC 61851', warranty: '3 ans' }
    },
    {
      name: 'Éclairage LED Philips Hue',
      category: 'Système d\'éclairage intelligent',
      capacity: 'Pack 15 luminaires',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Philips%20Hue%20smart%20LED%20lighting%20system%20with%20color-changing%20bulbs%20and%20modern%20fixtures%2C%20premium%20connected%20lighting%20with%20smartphone%20control%20showing%20warm%20ambient%20glow%2C%20high-end%20residential%20lighting%20solution%20with%20contemporary%20design%2C%20professional%20product%20photography%20displaying%20multiple%20light%20sources&width=800&height=600&seq=philips-hue&orientation=portrait',
      features: [
        'Spots encastrés LED Hue GU10',
        'Rubans LED RGB+ 5m',
        'Pont de connexion Hue Bridge',
        'Variateurs sans fil',
        'Scénarios personnalisables'
      ],
      specs: { brand: 'Philips Hue', standard: 'Zigbee 3.0', warranty: '3 ans' }
    },
    {
      name: 'Onduleur APC Smart-UPS',
      category: 'Protection électrique professionnelle',
      capacity: '3000 VA / 2700 W',
      image: 'https://readdy.ai/api/search-image?query=Professional%20APC%20Smart-UPS%20uninterruptible%20power%20supply%20in%20robust%20black%20tower%20design%20with%20LCD%20display%20panel%2C%20enterprise-grade%20backup%20power%20system%20with%20premium%20build%20quality%2C%20high-end%20electrical%20protection%20equipment%20with%20modern%20industrial%20styling%2C%20detailed%20product%20photography%20showing%20front%20control%20interface&width=800&height=600&seq=apc-smartups&orientation=portrait',
      features: [
        'Protection ligne interactive',
        'Autonomie 15-20 minutes',
        'Écran LCD multifonction',
        '8 prises IEC protégées',
        'Logiciel de gestion PowerChute'
      ],
      specs: { brand: 'APC by Schneider', standard: 'IEC 62040', warranty: '3 ans' }
    },
    {
      name: 'Interphone Vidéo Comelit',
      category: 'Système d\'interphonie IP',
      capacity: 'Villa individuelle',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20Comelit%20video%20intercom%20system%20with%20high-resolution%20touchscreen%20monitor%20in%20elegant%20black%20finish%2C%20premium%20IP%20door%20entry%20system%20with%20wide-angle%20camera%20and%20sleek%20aluminum%20outdoor%20panel%2C%20sophisticated%20home%20security%20communication%20device%20with%20modern%20minimalist%20design%2C%20professional%20product%20photography&width=800&height=600&seq=comelit-intercom&orientation=portrait',
      features: [
        'Écran tactile 7 pouces HD',
        'Caméra grand angle 170°',
        'Vision nocturne infrarouge',
        'Déverrouillage à distance',
        'Application smartphone'
      ],
      specs: { brand: 'Comelit', standard: 'IP/SIP', warranty: '5 ans' }
    },
    {
      name: 'Détection Incendie Siemens',
      category: 'Système de détection incendie',
      capacity: 'Centrale 8 zones',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Siemens%20fire%20detection%20control%20panel%20with%20digital%20display%20and%20status%20indicators%20in%20white%20housing%2C%20advanced%20fire%20alarm%20system%20with%20multiple%20zone%20monitoring%2C%20high-end%20building%20safety%20equipment%20with%20industrial-grade%20construction%2C%20detailed%20product%20photography%20showing%20control%20interface%20and%20LED%20indicators&width=800&height=600&seq=siemens-fire&orientation=portrait',
      features: [
        'Centrale adressable Siemens',
        '12 détecteurs optiques',
        '4 déclencheurs manuels',
        'Sirène intérieure/extérieure',
        'Certification EN 54'
      ],
      specs: { brand: 'Siemens', standard: 'EN 54 / AEAI', warranty: '5 ans' }
    },
    {
      name: 'Prises USB-C Feller EDIZIOdue',
      category: 'Appareillage électrique design',
      capacity: 'Pack 10 prises',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Feller%20EDIZIOdue%20electrical%20outlets%20with%20integrated%20USB-C%20ports%20in%20premium%20white%20finish%2C%20Swiss-made%20designer%20power%20sockets%20with%20modern%20minimalist%20aesthetic%20and%20metal%20frame%2C%20high-end%20residential%20electrical%20fittings%20with%20clean%20contemporary%20design%2C%20professional%20product%20photography%20on%20white%20background&width=800&height=600&seq=feller-usbc&orientation=portrait',
      features: [
        'Design suisse Feller',
        'Prises Schuko + USB-C 45W',
        'Charge rapide Power Delivery',
        'Finition premium au choix',
        'Garantie fabricant 10 ans'
      ],
      specs: { brand: 'Feller', standard: 'T13 Suisse', warranty: '10 ans' }
    },
    {
      name: 'Câblage Réseau Cat 8',
      category: 'Infrastructure réseau haut débit',
      capacity: 'Installation 8 points',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Category%208%20network%20cable%20installation%20with%20premium%20shielded%20ethernet%20cables%20and%20RJ45%20connectors%2C%20high-performance%20data%20center%20cabling%20infrastructure%20with%20organized%20cable%20management%2C%20enterprise-grade%20network%20equipment%20with%20copper%20conductors%20and%20gold-plated%20contacts%2C%20technical%20photography%20showing%20cable%20quality&width=800&height=600&seq=cat8-network&orientation=portrait',
      features: [
        'Câble Cat 8 blindé S/FTP',
        'Prises RJ45 Cat 8 Keystone',
        'Switch Gigabit 10 ports',
        'Certification Fluke DTX',
        'Garantie 25 ans câblage'
      ],
      specs: { brand: 'Certified Cat 8', standard: 'ISO/IEC 11801', warranty: '25 ans' }
    }
  ];

  return (
    <section id="produits" className="py-24 bg-gray-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-orange-400">Nos Produits Électriques</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Équipements Premium Conformes OIBT
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-400">
            Matériel électrique haut de gamme des plus grandes marques. Installation professionnelle certifiée avec garantie complète.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="bg-gray-800 rounded-2xl border border-gray-700 overflow-hidden hover:border-orange-500/40 transition-all">
              <div className="relative w-full h-80 bg-gray-700">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {product.specs.brand}
                </div>
              </div>
              <div className="p-6">
                <div className="mb-4">
                  <p className="text-sm text-orange-400 font-semibold mb-1">{product.category}</p>
                  <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                  <p className="text-sm text-gray-400">{product.capacity}</p>
                </div>
                <ul className="space-y-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-orange-400 mt-1 mr-2 flex-shrink-0"></i>
                      <span className="text-sm text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="border-t border-gray-700 pt-4 mb-6">
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-gray-500">Norme</p>
                      <p className="font-semibold text-gray-200">{product.specs.standard}</p>
                    </div>
                    <div>
                      <p className="text-gray-500">Garantie</p>
                      <p className="font-semibold text-gray-200">{product.specs.warranty}</p>
                    </div>
                  </div>
                </div>
                <a href="#contact" className="block w-full text-center rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold text-white hover:bg-orange-600 transition-all whitespace-nowrap cursor-pointer">
                  Demander un devis
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-gray-800 rounded-2xl p-8 border border-orange-500/20">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg flex-shrink-0">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2">Installation certifiée OIBT/NIBT</h3>
              <p className="text-gray-400 leading-relaxed mb-4">
                Tous nos équipements sont installés par des électriciens certifiés selon les normes suisses OIBT/NIBT en vigueur. Chaque installation fait l'objet d'un contrôle de conformité et d'une certification officielle.
              </p>
              <p className="text-gray-400 leading-relaxed">
                <strong className="text-white">Garantie complète:</strong> Matériel garanti par le fabricant, installation garantie 2 ans, intervention sous 24h en cas de problème. Service après-vente et maintenance disponibles.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
